/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {
    import fld = MarkupChargesRow.Fields;
    @Serenity.Decorators.registerClass()
    export class MarkupChargesEditor extends _Ext.GridEditorBase<MarkupChargesRow> {
        protected getColumnsKey() { return "OMS.MarkupCharges"; }
        protected getDialogType() { return MarkupChargesDialog; }
        protected getLocalTextPrefix() { return MarkupChargesRow.localTextPrefix; } 
        private pendingChanges: Q.Dictionary<any> = {};

        protected form: MarkupChargesForm;
        amount = 0; markup = 0;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });

        }
        public getColumns() {

            var columns = super.getColumns();
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            this.view.refresh();
            return columns;
        }
        // inline delete event handler
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        var id = this.id(item);
                        this.view.deleteItem(id);
                    });
                }
            }
        }

        validateEntity(row: MarkupChargesRow, id) {

            row.ProductTypeCode = OMS.ProductTypeRow.getLookup().itemById[row.ProductTypeId].ProductTypeCode;
            if (row.ItemTypeId != null && row.ItemTypeId > 0)
                row.ItemType = OMS.FixedCodeRow.getLookup().itemById[row.ItemTypeId].FixedName;
            return true;
        }
    }
}